/* eslint-disable react/destructuring-assignment */
import { ICellRendererParams } from 'ag-grid-enterprise'
import React, { useMemo } from 'react'
import { getFormattedValue } from './utils/valueFormatting'
import { showArrow } from '../customReportTable/utils'
import Arrow from '../../../../../components/Misc/Arrow'
import { CustomReportVariable } from '../../../../../redux/context/customReports/typesVariable'
import { TransposedRowData as GridRowData } from './utils/transposedRowData'
import Restricted from '../customReportTable/Restricted'

interface CategoryRowColumnContext {
  variable: CustomReportVariable
}

type CategoryRowCellRendererProps = ICellRendererParams

const CustomCategoryRowCellRenderer: React.FC<CategoryRowCellRendererProps> = props => {
  const { data, value, colDef } = props
  const colContext = colDef?.context as CategoryRowColumnContext
  const variable = colContext?.variable
  const rowData = data as GridRowData
  const leafCategory = rowData?.leafCategory

  const formattedValue = useMemo(
    () => getFormattedValue(value, variable, leafCategory),
    [value, variable, leafCategory]
  )

  const shouldShowArrow = useMemo(() => {
    return leafCategory ? showArrow(value, leafCategory, variable) : false
  }, [value, leafCategory, variable])

  const errors = useMemo(() => {
    // Find errors for this variable/category combination
    const balance = variable?.balances?.find(b => b.groupId === rowData?.categoryId)
    return balance?.errors || []
  }, [variable, rowData])

  // Show Restricted component if there are errors and no value
  if (errors && errors.length > 0 && (value === undefined || value === null)) {
    return <Restricted errors={errors} />
  }

  return (
    <div>
      {shouldShowArrow && value && (
        <Arrow value={value} thresholdValueSetting={variable?.style?.thresholdValueSetting} />
      )}
      <span>{formattedValue}</span>
    </div>
  )
}

export default CustomCategoryRowCellRenderer
